import { authHeaders } from './api';
import { API_URL } from './api';
import type { RunEvent } from '../types/api';

/** Reads the run's server-sent events. Reconnects from the last seen sequence number if the
 *  connection drops while the run is still going. */
export async function streamRun(runId: string, onEvent: (e: RunEvent) => void, signal: AbortSignal) {
  let after = -1;
  for (let attempt = 0; attempt < 6 && !signal.aborted; attempt++) {
    try {
      const res = await fetch(`${API_URL}/api/runs/${runId}/stream?after=${after}`, { credentials: 'include', signal, headers: authHeaders() });
      if (!res.ok || !res.body) throw new Error(`stream ${res.status}`);
      const reader = res.body.pipeThrough(new TextDecoderStream()).getReader();
      let buf = '';
      while (true) {
        const { value, done } = await reader.read();
        if (done) break;
        buf += value;
        let i: number;
        while ((i = buf.indexOf('\n\n')) >= 0) {
          const chunk = buf.slice(0, i);
          buf = buf.slice(i + 2);
          const data = chunk.split('\n').filter((l) => l.startsWith('data: ')).map((l) => l.slice(6)).join('\n');
          if (!data) continue;
          const ev = JSON.parse(data) as RunEvent;
          if (signal.aborted) return; // a newer subscription took over
          if (ev.seq <= after) continue;
          after = ev.seq;
          onEvent(ev);
          if (ev.type === 'run.done') return;
        }
      }
    } catch (e) {
      if (signal.aborted) return;
    }
    await new Promise((r) => setTimeout(r, 500 * 2 ** attempt));
  }
}
